import { ContactsState } from './contacts.interfaces';

export const contactsInitialState: ContactsState = {
  contacts: [],
  errors: null,
  isLoading: false,
  presences: {},
  groupConfiguration: {},
};
